export default __webpack_public_path__ + "acaa6a3c42b20e2d13c54272ca8b8a56.jpg";